// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB3Adx0X5F6ijvj9FaSF8ookROKpaC4g7w",
    authDomain: "spotip17an.firebaseapp.com",
    projectId: "spotip17an",
    messagingSenderId: "347709649224",
    appId: "1:347709649224:web:98ca9327e4d017aaa2837d",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
